// extracted by mini-css-extract-plugin
export default {"profile-avatar":"profile-avatar--SrTshCiTjiCoxspzVZ3x","profile-avatar--clickable":"profile-avatar--clickable--MCNpD0IHkOxn3Yu94CUA"};